module.exports = __webpack_public_path__ + "img/Weapon_175.5bb1dcdf.png";